/**
 * params: status, color override
*/
export const renderStatusColor = (status, overrides) => { 
  if (status !== "" && status !== undefined){
    const statusObject = {
      "draft": "label-gray",

      "pending": "label-yellow",
      "processing": "label-yellow",
      "awaiting_approval": "label-yellow",
      "in-review": "label-yellow",
      "frozen": "label-yellow",
      "inactive": "label-yellow",

      "processed": "label-blue",

      "success": "label-green",
      "successful": "label-green",
      "active": "label-green",
      "paid": "label-green",
      "completed": "label-green",
      "approved": "label-blue",
      "enrolled": "label-green",
      
      "failed": "label-red",
      "failed-credit": "label-red",
      "deactivate": "label-red",
      "deactivated": "label-red",
      "disable": "label-red",
      "disabled": "label-red",
      "cancelled": "label-red",
      "canceled": "label-red",
      "cut-off": "label-red",
      "rejected": "label-red",
      "unpaid": "label-red",

      "reversed": "label-gray",
    }

    if (overrides){
      const overrideskeys = Object.keys(overrides);

      const data = overrideskeys?.map((key) => {
        if (key.toLowerCase() === status.toLowerCase()){
          return overrides[key.toLocaleLowerCase()] || "";
        }
        else{
          return statusObject[status.toLocaleLowerCase()] || "";
        }
      })

      return data;
    }
    else{
      return statusObject[status.toLocaleLowerCase()] || "";
    }
  }
  return "";
};

export const renderRoleColor = (role, overrides) => { 
  if (role !== "" && role !== undefined){
    const roleObject = {
      "draft": "label-gray",

      "pending": "label-yellow",
      "processing": "label-yellow",
      "awaiting_approval": "label-yellow",
      "in-review": "label-yellow",
      "frozen": "label-yellow",
      "inactive": "label-yellow",

      "processed": "label-blue",
      "owner": "label-blue",

      "success": "label-green",
      "successful": "label-green",
      "active": "label-green",
      "paid": "label-green",
      "completed": "label-green",
      "approved": "label-green",
      "enrolled": "label-green",
      
      "failed": "label-red",
      "failed-credit": "label-red",
      "deactivate": "label-red",
      "deactivated": "label-red",
      "disable": "label-red",
      "disabled": "label-red",
      "cancelled": "label-red",
      "cut-off": "label-red",
      "rejected": "label-red",
      "unpaid": "label-red",

      "reversed": "label-gray",
    }

    if (overrides){
      const overrideskeys = Object.keys(overrides);

      const data = overrideskeys?.map((key) => {
        if (key.toLowerCase() === role.toLowerCase()){
          return overrides[key.toLocaleLowerCase()] || "";
        }
        else{
          return roleObject[role.toLocaleLowerCase()] || "";
        }
      })

      return data;
    }
    else{
      return roleObject[role.toLocaleLowerCase()] || "";
    }
  }
  return "";
};
